import { render, staticRenderFns } from "./ApproverRoot.vue?vue&type=template&id=b6e1ca2e&lang=pug&"
import script from "./ApproverRoot.vue?vue&type=script&lang=js&"
export * from "./ApproverRoot.vue?vue&type=script&lang=js&"
import style0 from "./ApproverRoot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports